import React from "react";
import "./About.css";
import Ayuda from "../Ayuda/Ayuda";
import imgConsulta from "../../Assets/nutricionista_con_paciente.jpeg";
import imgInbody from "../../Assets/nutricionista_con_paciente_en_inbody.jpeg";
import imgCursos from "../../Assets/desk2.webp";
import imgSuple from "../../Assets/desk5.webp";
import imgBio from "../../Assets/nutricionista_con_paciente_2.jpeg";

const SERVICES = [
  {
    num: "01",
    badge: "Consulta individual",
    title: "Consultas nutricionales",
    desc: "Atención personalizada con un enfoque integral para ayudarte a mejorar tu alimentación, tu salud y tu calidad de vida.",
    cta: "Agendar consulta →",
    href: "/calendar",
    external: false,
    image: imgConsulta,
    imageWidth: 1448,
    imageHeight: 1086,
  },
  {
    num: "02",
    badge: "Análisis corporal",
    title: "Análisis InBody 120",
    desc: "Evaluación corporal precisa para medir avances y personalizar tu plan alimentario con datos reales.",
    cta: "Agendar consulta →",
    href: "/calendar",
    external: false,
    image: imgInbody,
    imageWidth: 1448,
    imageHeight: 1086,
  },
  {
    num: "03",
    badge: "Tienda online",
    title: "Cursos y guías",
    desc: "Herramientas prácticas para aprender a organizar tu alimentación con claridad y autonomía.",
    cta: "Ir a la tienda →",
    href: "https://tienda.bianangelucci.com.ar/",
    external: true,
    tienda: true,
    image: imgCursos,
    imageWidth: 1200,
    imageHeight: 562,
  },
  {
    num: "04",
    badge: "Próximamente",
    title: "Suplementos",
    desc: "Fórmulas seleccionadas para objetivos específicos de salud, con respaldo nutricional profesional.",
    cta: "Ir a la tienda →",
    href: "https://tienda.bianangelucci.com.ar/",
    external: true,
    tienda: true,
    image: imgSuple,
    imageWidth: 1200,
    imageHeight: 562,
  },
];

const METODO = [
  "Evaluación inicial + InBody",
  "Objetivos realistas y medibles",
  "Plan alimentario personalizado",
  "Seguimiento y ajustes",
];

const About = () => (
  <>
    {/* ── Servicios ─────────────────────────────────────── */}
    <section className="services-section" id="services">
      <div className="services-inner">
        <p className="about-label">¿Cómo puedo acompañarte?</p>
        <h2 className="about-section-title">Elegí el servicio que <span className="deco-underline">necesitás</span></h2>
        <div className="services-grid">
          {SERVICES.map((s) => (
            <div key={s.num} className="service-card">
              {s.image && (
                <img
                  src={s.image}
                  alt={s.title}
                  className="service-card-img"
                  loading="lazy"
                  width={s.imageWidth}
                  height={s.imageHeight}
                />
              )}
              <div className="service-num">{s.num}</div>
              <span className={`service-badge${s.tienda ? " tienda" : ""}`}>{s.badge}</span>
              <h3 className="service-card-title">{s.title}</h3>
              <p className="service-card-desc">{s.desc}</p>
              <a
                href={s.href}
                className="card-cta"
                {...(s.external ? { target: "_blank", rel: "noreferrer" } : {})}
              >
                {s.cta}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>

    <Ayuda />

    {/* ── Sobre mí ───────────────────────────────────────── */}
    <section className="bio-section" id="about">
      <div className="bio-inner">
        <img
          src={imgBio}
          alt="Bianca Angelucci en consulta"
          className="bio-photo"
          loading="lazy"
          width="1448"
          height="1086"
        />
        <div className="bio-right">
          <div className="bio-left">
            <p className="about-label">Sobre mí</p>
            <h2 className="bio-name">Lic. Bianca Angelucci</h2>
            <p className="bio-mp">M.P. 1847/1</p>
            <p className="bio-text">
              Te acompaño desde un enfoque integral que une nutrición, salud metabólica,
              hábitos y educación alimentaria. El objetivo no es darte una dieta aislada,
              sino construir una estrategia que puedas sostener y adaptar a tu vida real.
            </p>
            <a href="/calendar" className="bio-cta">Agendar consulta</a>
          </div>

          <div className="metodo-card">
            <h4 className="metodo-title">Mi método</h4>
            {METODO.map((step, i) => (
              <div key={i} className="metodo-step">
                <span className="step-num">{i + 1}</span>
                {step}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  </>
);

export default About;
